import "./TaskPriority.scss";

function TaskPriority({
  updatePriority,
  selectedPriority,
  priorityConfig = [],
}) {
  return (
    <div className="priority-content">
      {priorityConfig.map((priorityItem, index) => (
        <div
          key={priorityItem.label}
          className={`priority ${selectedPriority === index ? "selected" : ""}`}
          onClick={() => updatePriority(index)}
          style={{
            backgroundColor: priorityItem.color,
          }}
        >
          {priorityItem.label}
        </div>
      ))}
      <hr className="separator" />
      <div className="clear-button" onClick={() => updatePriority(null)}>
        Clear
      </div>
    </div>
  );
}

export default TaskPriority;
